import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import PreviousRound from "../../previousround/PreviousRound";
import CandidateList from "../candidatelist/CandidateList";
import InterviewLevel from "../interviewlevel/InterviewLevel";

export default function ParticularCandidates({ cid }) {

    const [previous, setPrevious] = useState([]);

    const { authData, backUrl } = useContext(AuthContext)


    const handlePrevious = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/candidates/all_interview_levels/?candidate_id=${cid}`,
                { headers: { Authorization: `Bearer ${authData?.access}` } });
            setPrevious(res.data.interview_levels)
            console.log("candidate", res.data.interview_levels)
        } catch (error) {
            console.error("Error fetching interview levels:", error);
        }
    }
    useEffect(() => {
        handlePrevious();
    }, [])


    return (
        <>
            {/* <h5>Candidate Details</h5> */}

            <>
                {/* <PreviousRound id={cid} previous={previous} />
                <CandidateList/> */}
                <InterviewLevel cid={cid}/>
            </>

        </>
    )
}